import { Instance } from 'mobx-state-tree';
import { PharmacyStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Municipality } from '../../../store/models/Municipality';

interface MunicipalityFormFieldProps extends WithTranslateProps {
  MunicipalityStore?: Instance<typeof PharmacyStore>;
  municipalityList?: Array<Instance<typeof Municipality>>;
}

@inject('MunicipalityStore')
@observer
class MunicipalityFormField extends React.Component<MunicipalityFormFieldProps> {
  renderMunicipalityMenuItem(
    item: Instance<typeof Municipality>,
    { handleClick, index, modifiers }: IItemRendererProps,
  ) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`Municipality-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.postalCode + ' ' + item.nameFR! + '(' + item.mainNameFR + ')'}
        />
      );
    } else {
      return null;
    }
  }

  filterMunicipality = (query, Municipality) => {
    return (
      (
        Municipality.postalCode.toString() +
        ' ' +
        Municipality.nameFR!.toLowerCase() +
        ' ' +
        Municipality.mainNameFR!.toLowerCase()
      ).indexOf(query.toLowerCase()) >= 0
    );
  };

  render() {
    const { municipalityList, MunicipalityStore, ...otherProps } = this.props;

    return (
      <SelectInputFormField
        label={TLCode.MUNICIPALITY_EntityNameFr}
        name="municipalityId"
        inline={true}
        items={toJS(municipalityList)}
        itemValueGetter={(item: any) => item.municipalityId}
        valueItemGetter={(value) => MunicipalityStore!.getById(value)!}
        inputValueRenderer={(item) =>
          item != null ? item.postalCode + ' ' + item.nameFR! + '(' + item.mainNameFR + ')' : ''
        }
        itemRenderer={this.renderMunicipalityMenuItem}
        itemPredicate={this.filterMunicipality}
        // allowEmpty={true}
        identifier={'municipalityId'}
        elementLabel={'municiaplity'}
        labelSelectAnElement={this.props.translate(TLCode.TRANSFER_CHOOSE_A_Municipality)}
        helperText={this.props.translate(TLCode.TRANSFER_CHOOSE_A_Municipality)}
        placeholderSelection={TLCode.TRANSFER_CHOOSE_A_Municipality}
        {...otherProps}
      />
    );
  }
}

export default withTranslate(MunicipalityFormField);
